import { useMe } from 'src/hooks'
import { Box, Typography, useTheme } from '@mui/material'
import { DotLoader } from 'src/components/dot-loader'
import { IWebChatbotHistoryResp } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'
import parse from 'html-react-parser'

interface IProps {
  dummyData?: IWebChatbotHistoryResp[] | null
  data: IWebChatbotHistoryResp[]
  isLoading: boolean
}

export const WebChatBotHistory = ({ data, isLoading, dummyData = null }: IProps) => {
  const theme = useTheme()

  const { data: user, isLoading: isMeLoading } = useMe()

  if (isLoading || !data || isMeLoading) {
    return null
  }

  const datatoMap = dummyData || data

  return (
    <Box sx={{ padding: '10px 0px', overflowY: 'auto' }}>
      {datatoMap.map((message, index) => {
        const isUserMessage = message.sender === 'user'
        const content = message.text

        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '5px',
              mb: 2,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 'bold',
                color: isUserMessage ? theme.palette.custom.black : theme.palette.custom.primary,
              }}
            >
              {isUserMessage ? 'You' : 'Traicy'}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
                alignItems: 'flex-start',
                backgroundColor: isUserMessage
                  ? theme.palette.custom.grey
                  : theme.palette.custom.secondary,
                padding: !isUserMessage && dummyData ? '0px 20px' : '10px 10px 3px 10px',
                borderRadius: '10px',
                maxWidth: '100%',
                wordWrap: 'break-word',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  width: '100%',
                  // whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                }}
              >
                {!isUserMessage && dummyData ? (
                  <DotLoader isStatic size={24} color={theme.palette.custom.black} />
                ) : (
                  parse(content)
                )}
              </Typography>
              {(!dummyData || isUserMessage) && (
                <Box
                  sx={{
                    alignSelf: 'end',
                    fontSize: '11px',
                    fontWeight: 600,
                    color: theme.palette.custom.grey2,
                  }}
                >
                  {getTableTimestamp({ date: message.created_at, timezone: user?.timezone })}
                </Box>
              )}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}
